export const loadingSvg = (
  <svg
    className="w-5 h-5 mr-3 -ml-1 text-white animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const typeToHuman: Record<string, string> = {
  DELIVERY: 'Entrega',
  PENDING: 'Pendente',
  REJECTED: 'Cancelado X',
  PREPARATION: 'Em Preparo',
  OUT_FOR_DELIVERY: 'Saiu Para Entrega',
  DELIVERED: 'Entregue',
  WITHDRAWAL: 'Retirada',
};

export const typeToHumanColor = {
  DELIVERY: { color: '#0088ff', label: 'Entrega' },
  PENDING: { color: '#ff8400', label: 'Pendente' },
  REJECTED: { color: '#c7000a', label: 'Cancelado' },
  CANCELED: { color: '#c7000a', label: 'Cancelado' },
  FAILED: { color: '#c7000a', label: 'Falha' },
  WHATSAPP: { color: '#9c9c9c', label: 'Via whatsapp' },
  PREPARATION: { color: '#ff8400', label: 'Em preparo' },
  OUT_FOR_DELIVERY: { color: '#ff8400', label: 'Saiu para entrega' },
  DELIVERED: { color: '#3da628', label: 'Entregue' },
  WITHDRAWAL: { color: '#3da628', label: 'Retirada' },
};

export const pagarmeToHumanColor = {
  processing: { color: '#ff8400', label: 'Processando' },
  captured: { color: '#3da628', label: 'Pago' },
  authorized: { color: '#3da628', label: 'Autorizado' },
  paid: { color: '#3da628', label: 'Pago' },
  canceled: { color: '#c7000a', label: 'Cancelado' },
  failed: { color: '#c7000a', label: 'Falha no pagamento' },
  not_authorized: { color: '#c7000a', label: 'Não autorizado' },
  refunded: { color: '#c7000a', label: 'Estornado' },
  pending: { color: '#ff8400', label: 'Aguardando pagamento' },
  waiting_payment: { color: '#ff8400', label: 'Aguardando pagamento' },
  pending_refund: { color: '#ff8400', label: 'Aguardando estorno' },
  refused: { color: '#c7000a', label: 'Recusado' },
  chargedback: { color: '#c7000a', label: 'Chargeback' },
  analyzing: { color: '#ff8400', label: 'Em análise' },
  pending_review: { color: '#ff8400', label: 'Revisão' },
};

export const typeLinks = {
  INSTAGRAM: 'Instagram',
  WHATSAPP: 'Whatsapp',
  MAPS: 'Localização',
};

export const colors = {
  '#1b9051': 'theme-green',
  '#000000': 'theme-black',
  '#F61F1B': 'theme-red',
  '#a62707': 'theme-red-dark',
  '#173189': 'theme-blue',
  '#5E1593': 'theme-purple',
  '#F87622': 'theme-orange',
  '#FFE135': 'theme-yellow',
};

export const daysOfWeek = {
  MON: 'Segunda',
  TUE: 'Terça',
  WED: 'Quarta',
  THU: 'Quinta',
  FRI: 'Sexta',
  SAT: 'Sábado',
  SUN: 'Domingo',
};

export enum ProductType {
  KG = 'KG',
  UNIT = 'UNIT',
}

export enum PaymentMethodType {
  PIX = 'PIX',
  MONEY = 'Dinheiro',
  CHECKOUT_CREDIT_CARD = 'CHECKOUT_CREDIT_CARD',
  CHECKOUT_PIX = 'CHECKOUT_PIX',
}

export enum DeliveryType {
  DELIVERY = 'DELIVERY',
  WITHDRAWAL = 'WITHDRAWAL',
  UBER = 'UBER',
}

export enum DeliveryMerchantType {
  DELIVERY = 'DELIVERY',
  WITHDRAWAL_AND_DELIVERY = 'WITHDRAWAL_AND_DELIVERY',
  WITHDRAWAL = 'WITHDRAWAL',
}

export enum WherePaymentType {
  APP = 'APP',
  WITHDRAWALORDELIVERY = 'WITHDRAWALORDELIVERY',
}

export enum StepType {
  ADDRESS = 'ADDRESS',
  SCHEDULING = 'SCHEDULING',
  DELIVERY_INSTRUCTIONS = 'DELIVERY_INSTRUCTIONS',
  FINISHED = 'FINISHED',
  NONE = 'NONE',
}

export enum StatusType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
}

const dias: Record<string, string> = {
  MON: 'Segunda-Feira',
  TUE: 'Terça-Feira',
  WED: 'Quarta-Feira',
  THU: 'Quinta-Feira',
  FRI: 'Sexta-Feira',
  SAT: 'Sabado',
  SUN: 'Domingo',
};

export enum mobileSize {
  mobile = 768,
}

export default function weekDayToHuman(day?: string) {
  if (!day) return '';
  return dias[day];
}
